export default __webpack_public_path__ + "static/media/peek.50d2b246.png";